export default __webpack_public_path__ + "static/media/actividadesempleados.9caec847.png";